import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createSortaFriendsClickHandler } from '../utils/navigation';

const Rules = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/login');
  };

  return (
    <div>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <h1 style={{ cursor: 'pointer' }} onClick={createSortaFriendsClickHandler(navigate)}>SortaFriends</h1>
            <button
              onClick={handleBack}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="card">
          <h1>Community Rules</h1>
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>
          
          <p style={{ fontSize: '18px', color: 'var(--color-text-muted)', marginBottom: '30px' }}>
            SortaFriends is an adults-only (18+) community. Mature themes, suggestive topics, and strong language may appear. These rules keep the space safe and respectful. By using our platform, you agree to follow these guidelines.
          </p>

          <h2>1. Be Respectful</h2>
          <p>Treat others with kindness and respect. Everyone deserves to feel welcome and safe in our community.</p>
          <ul>
            <li>Use polite and constructive language</li>
            <li>Respect different opinions and perspectives</li>
            <li>Don't mock or belittle others</li>
            <li>Be supportive of new community members</li>
          </ul>

          <h2>2. No Hate Speech or Harassment</h2>
          <p>We have zero tolerance for hate speech, harassment, or threats of any kind.</p>
          <ul>
            <li>No discrimination based on race, ethnicity, religion, gender, sexual orientation, disability, or any other characteristic</li>
            <li>No bullying, stalking, or targeted harassment</li>
            <li>No threats of violence or harm</li>
            <li>No incitement of hatred or violence</li>
          </ul>

          <h2>3. Keep Content Within Adult Guidelines</h2>
          <p>Our platform is intended for users 18 and older. Adult-oriented discussion is allowed, but explicit sexual content or pornography is not permitted.</p>
          <ul>
            <li>No explicit sexual content, pornography, or sexual exploitation</li>
            <li>No graphic violence or gore</li>
            <li>No content that promotes or glorifies self-harm or dangerous activities</li>
          </ul>

          <h2>4. No Spam or Scams</h2>
          <p>Keep the platform clean and trustworthy for everyone.</p>
          <ul>
            <li>No repetitive or unwanted promotional content</li>
            <li>No phishing attempts or fraudulent schemes</li>
            <li>No misleading or false information</li>
            <li>No pyramid schemes or get-rich-quick scams</li>
          </ul>

          <h2>5. Be Authentic</h2>
          <p>Be yourself and be honest about who you are.</p>
          <ul>
            <li>No impersonation of other people or organizations</li>
            <li>No fake accounts or sock puppets</li>
            <li>No pretending to be someone you're not</li>
            <li>Use your real identity when possible</li>
          </ul>

          <h2>6. No Automation</h2>
          <p>Use the site as intended.</p>
          <ul>
            <li>No bots, scripts, or automated tools</li>
            <li>No manipulation of rankings</li>
          </ul>

          <h2>7. Respect Intellectual Property</h2>
          <p>Only share content that you have the right to share.</p>
          <ul>
            <li>Don't post copyrighted material without permission</li>
            <li>Give credit when using others' work</li>
            <li>Respect trademarks and brand names</li>
            <li>Report content that infringes on your rights</li>
          </ul>

          <h2>8. Stay On Topic</h2>
          <p>Keep discussions and content relevant to the platform's purpose.</p>
          <ul>
            <li>Create meaningful and relevant stacks</li>
            <li>Engage in constructive discussions</li>
            <li>Don't derail conversations with off-topic content</li>
            <li>Respect the purpose of different groups and spaces</li>
          </ul>

          <h2>9. Consequences</h2>
          <p>Violating these rules may result in:</p>
          <ul>
            <li>Content removal</li>
            <li>Temporary or permanent feature restrictions</li>
            <li>Permanent account deletion</li>
            <li>Legal action in severe cases</li>
          </ul>

          <h2>Appeals</h2>
          <p>If you believe your content was removed or your account was deleted in error, you may appeal by contacting us at admin@sortafriends.com. Please include:</p>
          <ul>
            <li>Your username</li>
            <li>Details about the action taken</li>
            <li>Why you believe it was in error</li>
            <li>Any relevant context or evidence</li>
          </ul>

          <h2>Updates to Rules</h2>
          <p>We may update these rules from time to time to keep our community safe and enjoyable. We'll notify users of significant changes through the platform or email.</p>

          <div style={{ 
            marginTop: '40px', 
            padding: '20px', 
            backgroundColor: 'var(--color-surface)', 
            border: '1px solid var(--color-border)', 
            borderRadius: '8px' 
          }}>
            <h3 style={{ marginTop: 0, color: 'var(--color-primary)' }}>Remember</h3>
            <p style={{ marginBottom: 0 }}>
              These rules exist to make SortaFriends a better place for everyone. When in doubt, ask yourself: "Would I want someone else to treat me this way?" If the answer is no, it's probably against the rules.
            </p>
          </div>

          <div style={{ marginTop: '30px', textAlign: 'center' }}>
            <button
              onClick={handleBack}
              className="btn"
              style={{ backgroundColor: 'var(--color-primary)', color: 'white', border: 'none' }}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rules;
